export const THEME_DATA_TARGET = 'data-theme'

export const THEME_DATA_OPTIONS = {
  light: 'light',
  dark: 'dark',
}

export const THEME_STORAGE_KEY = 'hindsight.user.prefersLightMode'
